import React, { useState, useEffect } from 'react';
import styles from '../styles/Login.module.css';
import OrderService from '../services/orderService.js';
import HashParameterService from '../services/hashParameterService.js';
import LoadingIndicator from './LoadingIndicator.jsx';
import Header from './ProofOfDeliveryLayout/Header/Header.jsx';

const Login = (props) => {
    const [customerId, setCustomerId] = useState('');
    const [orderId, setOrderId] = useState('');
    const [hashParamService] = useState(new HashParameterService());
    const [orderService] = useState(new OrderService());
    const [showInvalidCredentials, setShowInvalidCredentials] = useState(false);
    const [showError, setShowError] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        login(customerId, orderId);
    };

    const login = (customerId, orderId) => {
        setShowInvalidCredentials(false);
        setShowError(false);
        setLoading(true);

        const error = (data) => {
            setShowInvalidCredentials(false);
            setShowError(true);
            setLoading(false);
        };

        orderService.getOrder(customerId, orderId, (orderData) => {
            if (!orderData) {
                setShowInvalidCredentials(true);
                setShowError(false);
                setLoading(false);
                return;
            }
            hashParamService.updateParameter('advertiser', customerId);
            hashParamService.updateParameter('order', orderId);

            props.onLogin(orderData, customerId);
        }, error);
    };

    useEffect(() => {
        const advertiser = hashParamService.getParameter('advertiser');
        const order = hashParamService.getParameter('order');

        if (advertiser.length > 0 && order.length > 0) {
            setCustomerId(advertiser);
            setOrderId(order);
            login(advertiser, order);
        } else {
            document.getElementById("customer_input").focus();
        }
    }, []);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
            <Header showExportButton={false} />
            <LoadingIndicator loading={loading} />
            <div style={{ display: 'flex', flexGrow: '1' }}>
                <div className={styles.containerLogin}>
                    <div className={styles.formWrapper}>
                        <div className={styles.formContainerLogin}>
                            <form onSubmit={handleSubmit}>
                                <div className={styles.fieldContainer}>
                                    <span className={styles.fieldLabelInner}>Advertiser ID</span>
                                    <input
                                        id="customer_input"
                                        type="text"
                                        value={customerId}
                                        onChange={(e) => setCustomerId(e.target.value)}
                                        className={styles.inputLogin}
                                    />
                                </div>
                                <div className={styles.fieldContainer}>
                                    <span className={styles.fieldLabelInner}>Order ID</span>
                                    <input
                                        type="text"
                                        value={orderId}
                                        onChange={(e) => setOrderId(e.target.value)}
                                        className={styles.inputLogin}
                                    />
                                </div>
                                <div className={styles.buttonContainerLogin}>
                                    <button type="submit" className={styles.buttonLogin}>
                                        Login
                                    </button>
                                </div>
                            </form>
                        </div>

                        <div className={styles.errorContainer}>
                            {showInvalidCredentials &&
                                <div className={styles.errorMessage}>
                                    Invalid Customer-id or Proposal-id.
                                </div>
                            }
                            {showError &&
                                <div className={styles.errorMessage}>
                                    Something went wrong!
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default Login;